import { readonly } from "vue";
import SharedBaseOption from "%/dynamic-component-editor/classes/shared-base-option";

export default class BaseOption extends SharedBaseOption {

  constructor(values = {}, hideFromInspector = false, useInspectorLabel = true, overrideLabel = null) {
    super(hideFromInspector, useInspectorLabel);

    if (overrideLabel) {
      this.overrideLabel = overrideLabel;
    }

    if (this.constructor.defaultStateValues) {
      this.stateValues = this.constructor.defaultStateValues;
    } else {
      // Don't freeze rich text objects
      const defaultValue = this.shouldNotFreeze(this.constructor.defaultValue)
        ? this.constructor.defaultValue
        : Object.freeze(this.constructor.defaultValue);

      this.stateValues[this.constructor.$states.DEFAULT] = defaultValue;

      if (this.constructor.defaultHoverValue) {
        this.stateValues[this.constructor.$states.HOVER] = this.shouldNotFreeze(this.constructor.defaultHoverValue)
          ? this.constructor.defaultHoverValue
          : Object.freeze(this.constructor.defaultHoverValue);
      } else {
        this.stateValues[this.constructor.$states.HOVER] = defaultValue;
      }
    }

    if (values) {
      Object.values(this.constructor.$states).forEach(state => {
        if (values[state] !== undefined) {
          this.stateValues[state] = this.shouldNotFreeze(values[state])
            ? values[state]
            : Object.freeze(values[state]);
        }
      });
    }

    this.stateValues = readonly(this.stateValues);
  }

  shouldNotFreeze(value) {
    return value && typeof value === "object";
  }

  // get all state values
  getValueOrDefault(options = {}) {
    const result = {};
    Object.values(BaseOption.$states).forEach(state => {
      let value = options[`${state}.${this.optionKey}`];

      if (value === undefined) {

        if (Array.isArray(this.ignoreDefaultIfNotSetForState) && this.ignoreDefaultIfNotSetForState.includes(state)) {
          result[`${state}.${this.optionKey}`] = "";
          return;
        }

        value = options[`${BaseOption.$states.DEFAULT}.${this.optionKey}`];
      }

      if (value === undefined) {
        value = this.stateValues[state];
      }

      if (value === undefined) {
        value = this.stateValues[BaseOption.$states.DEFAULT];
      }

      result[`${state}.${this.optionKey}`] = this.constructor.getModifiedRawValue(value, options, state);
    });
    return result;
  }

  // get specific state value
  getValueFromConfiguration(configurationOptionValues, state = BaseOption.$states.DEFAULT, themeId = null, themeMode) {
    let defaultValue = this.stateValues[state] ?? this.stateValues[BaseOption.$states.DEFAULT];
    let key = this.optionKey;

    const defaultKey = `default.${key}`;
    if (configurationOptionValues[defaultKey] !== undefined) {
      defaultValue = configurationOptionValues[defaultKey];
    }

    const stateKey = `${state}.${key}`;
    let optionValue = configurationOptionValues[stateKey];

    if (optionValue === undefined) {
      if (Array.isArray(this.ignoreDefaultIfNotSetForState) && this.ignoreDefaultIfNotSetForState.includes(state)) {
        return "";
      }

      optionValue = defaultValue;
    }

    return this.constructor?.getValue(optionValue, themeId, themeMode, configurationOptionValues);
  }
}
